var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!this.datas[0].x.length > 0)?_c('div',[_c('h3',[_vm._v(" No "+_vm._s(_vm.title)+" data available in the database ")])]):_c('div',[_c('Plotly',{attrs:{"data":_vm.data,"layout":_vm.layout,"display-mode-bar":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44fb72d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlotlyComponent.vue
// module id = null
// module chunks = 